import React, { useState, useEffect } from 'react';
import logo from './logo.svg';
import './App.css';
import VocabularyPractice from './VocabularyPractice';
import CategoryTest from './CategoryTest';
import VocabularyExtension from './VocabularyExtension';
import QaSceneLearning from './QaSceneLearning';
import QaSceneLearningCnToEn from './QaSceneLearningCnToEn';
import LinkingVerbPage from './LinkingVerbPage';
import SentencesTest from './SentencesTest';
import WrongNotebookReview from './WrongNotebookReview';

function App() {
  const [showCategoryTest, setShowCategoryTest] = useState(false);
  const [showVocabularyExtension, setShowVocabularyExtension] = useState(false);
  const [showQaSceneLearning, setShowQaSceneLearning] = useState(false);
  const [showQaSceneLearningCnToEn, setShowQaSceneLearningCnToEn] = useState(false);
  const [showLinkingVerbPage, setShowLinkingVerbPage] = useState(false);
  const [showSentencesTest, setShowSentencesTest] = useState(false);
  const [showWrongNotebookReview, setShowWrongNotebookReview] = useState(false);

  // 在组件加载时执行API测试
  useEffect(() => {
    // 动态加载测试脚本
    const script = document.createElement('script');
    script.src = '/static/js/test_api.js'; // 路径已更新为public目录下的static/js文件夹
    script.onload = () => {
      console.log('API测试脚本加载完成');
    };
    script.onerror = (error) => {
      console.error('API测试脚本加载失败:', error);
    };
    document.body.appendChild(script);

    // 检查URL参数，决定显示哪个页面
    const params = new URLSearchParams(window.location.search);
    setShowCategoryTest(params.has('test') && params.get('test') === 'category');
    setShowVocabularyExtension(params.has('extension') && params.get('extension') === 'vocabulary');
    setShowQaSceneLearning(params.has('learning') && params.get('learning') === 'qa-scene');
    setShowQaSceneLearningCnToEn(params.has('learning') && params.get('learning') === 'qa-scene-cn-to-en');
    setShowLinkingVerbPage(params.has('page') && params.get('page') === 'linking-verbs');
    setShowSentencesTest(params.has('test') && params.get('test') === 'sentences');
    setShowWrongNotebookReview(params.has('review') && params.get('review') === 'wrong-notebook');

    // 监听URL变化
    const handlePopState = () => {
      const newParams = new URLSearchParams(window.location.search);
      setShowCategoryTest(newParams.has('test') && newParams.get('test') === 'category');
      setShowVocabularyExtension(newParams.has('extension') && newParams.get('extension') === 'vocabulary');
      setShowQaSceneLearning(newParams.has('learning') && newParams.get('learning') === 'qa-scene');
      setShowQaSceneLearningCnToEn(newParams.has('learning') && newParams.get('learning') === 'qa-scene-cn-to-en');
      setShowLinkingVerbPage(newParams.has('page') && newParams.get('page') === 'linking-verbs');
      setShowSentencesTest(newParams.has('test') && newParams.get('test') === 'sentences');
      setShowWrongNotebookReview(newParams.has('review') && newParams.get('review') === 'wrong-notebook');
    };

    window.addEventListener('popstate', handlePopState);

    // 组件卸载时移除脚本和事件监听器
    return () => {
      document.body.removeChild(script);
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);

  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          英语词汇练习应用
        </p>
        <div style={{ marginTop: '10px' }}>
          <button
            onClick={() => window.location.search = ''}
            style={{ marginRight: '10px', padding: '5px 10px' }}
          >
            回到主应用
          </button>
          <button
            onClick={() => window.location.search = '?test=category'}
            style={{ marginRight: '10px', padding: '5px 10px' }}
          >
            测试分类加载
          </button>
          <button
            onClick={() => window.location.search = '?extension=vocabulary'}
            style={{ marginRight: '10px', padding: '5px 10px' }}
          >
            词汇扩展练习
          </button>
          <button
            onClick={() => window.location.search = '?learning=qa-scene'}
            style={{ marginRight: '10px', padding: '5px 10px' }}
          >
            场景化问答学习（英到中）
          </button>
          <button
            onClick={() => window.location.search = '?learning=qa-scene-cn-to-en'}
            style={{ marginRight: '10px', padding: '5px 10px' }}
          >
            场景化问答学习（中到英）
          </button>
          <button
            onClick={() => window.location.search = '?test=sentences'}
            style={{ marginRight: '10px', padding: '5px 10px' }}
          >
            Sentences 接口测试
          </button>
          <button
            onClick={() => window.location.search = '?page=linking-verbs'}
            style={{ padding: '5px 10px' }}
          >
            系动词大全
          </button>
          <button
            onClick={() => window.location.search = '?review=wrong-notebook'}
            style={{ marginLeft: '10px', padding: '5px 10px' }}
          >
            错题复习
          </button>
        </div>
      </header>
      <main>
        {showSentencesTest ? (
          <SentencesTest />
        ) : showLinkingVerbPage ? (
          <LinkingVerbPage />
        ) : showWrongNotebookReview ? (
          <WrongNotebookReview />
        ) : showQaSceneLearningCnToEn ? (
          <QaSceneLearningCnToEn />
        ) : showQaSceneLearning ? (
          <QaSceneLearning />
        ) : showVocabularyExtension ? (
          <VocabularyExtension />
        ) : showCategoryTest ? (
          <CategoryTest />
        ) : (
          <VocabularyPractice />
        )}
      </main>
      <footer className="icp-footer">
        <a href="http://beian.miit.gov.cn/" target="_blank" rel="noreferrer">粤ICP备2025509815号-1</a>
      </footer>
    </div>
  );
}

export default App;
